"use strict";
var _ = require("lodash");
var VkIdUtils_1 = require("../../app/utils/VkIdUtils");
_.extend(window["AppUtils"], {
    VkId: VkIdUtils_1.default
});
//# sourceMappingURL=VkIdUtils.js.map